<template>
  <div class="upload-file">
    <el-upload  multiple :disabled="loading"   :on-change="change" :on-progress="onUpload" :action="uploadFileUrl"  :before-upload="handleBeforeUpload" :file-list="fileList" :on-error="handleUploadError" :on-success="handleUploadSuccess" :show-file-list="false" :headers="headers" name="xfile" class="upload-file-uploader" ref="uploadFile">
      <!-- 上传按钮 -->
      <!-- <el-button size="mini" type="primary">文件上传</el-button> -->
      <el-button size="small" icon="el-icon-plus" :disabled="loading">文件上传</el-button>
      <!-- 上传提示 -->
      <div class="el-upload__tip ts_18PX" slot="tip" v-if="showTip">
        请上传
        <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
        的文件，上传文件过大时，请稍等片刻
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <ul class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear">
      <li class="el-upload-list__item ele-upload-list__item-content" v-for="(file, index) in fileList" :key="file.uid">
        <el-link :href="`${file.url}`" :underline="false" target="_blank">
          <img src="@/assets/images/policy_img/icon_fujian@2x.png" alt="" width="19"> {{ getFileName(file.url,index)}}
          {{file.name}}
        </el-link>
        <div class="ele-upload-list__item-content-action">
          <el-link :underline="false" @click="handleDelete(index)" type="danger">删除</el-link>
        </div>
      </li>
    </ul>
    <el-progress v-if="status" :percentage="progressPercent" style="width:140px"  />

  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import axios from "axios";
export default {
  name: "FileUpload",
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: "",
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 20,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["doc", "xlsx", "pdf", "png", "jpg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: false,
    },
    urlType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadFileUrl: process.env.NODE_ENV_TOW + "/file/upload-file",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      fileList: [],
      loading: false,
      hasLimit: 0,
      progressPercent:0,
      status:false,
    };
  },
  watch: {
    urlType: {
      handler(val) {
        if (val == 2) {
          this.uploadFileUrl =
            process.env.NODE_ENV_TOW + "/file/upload-file-watermark";
        } else {
          this.uploadFileUrl = process.env.NODE_ENV_TOW + "/file/upload-file";
        }
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(",");
          // 然后将数组转为对象数组
         this.fileList= list.map((item) => {
            if (typeof item === "string") {
              item = { name: item, url: item };
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
          console.log(this.fileList)
        } else {
          this.fileList = [];
          return [];
        }

      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    change(file){
      this.progressPercent = 0
      if (file.status == 'ready') {
        this.status = true //进度条显示
        // const interval = setInterval(() => {
        //   if (this.progressPercent >= 99) {
        //      clearInterval(interval)
        //     return
        //   }
        //   this.progressPercent += 1 //进度条进度
        // }, 20)
      }
      if (file.status == 'success') {
           setTimeout(() => {
            this.status = false
				},3000)
          this.progressPercent = 100
        }

    },


     //上传时
    onUpload(event, file, fileList){
        // this.status = true
        const { loaded, total } = event
        this.progressPercent = ((loaded / total) * 100) | 0

    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
        // this.status = true
        // this.progressPercent=0
        this.loading = true;
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请重新上传!`
            // `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          this.loading = false;
          this.status = false
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          this.loading = false;
          return false;
        }
      }
      return true;
    },
    // 文件个数超出
    // handleExceed(files, fileList) {
    //   this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    //   this.loading = false;
    // },
    // 上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error("上传失败, 请重试");
      this.loading = false;
    },
    // 上传成功回调
    handleUploadSuccess(res, file, fileList) {
      this.hasLimit = this.fileList.length || 0;
      this.loading = false;
      if (res.code == 200) {
        //  setTimeout(() => {
        //     this.status=false
				// },3000)
        this.hasLimit++;
        if (this.hasLimit == this.limit) {
          this.loading = true;
        }
        this.$message.success("上传成功");
        this.fileList.push({ name: res.data, url: res.data });
        this.$emit("fileInput", this.listToString(this.fileList));

      } else {
        if (this.hasLimit <= 0) {
          this.hasLimit = 0;
        } else if (this.hasLimit <= this.limit) {
          this.loading = false;
        }
        this.$message.error(res.msg);
      }
    },
    // 删除文件
    handleDelete(index) {
      this.hasLimit--;
      if (this.hasLimit <= 0) {
        this.hasLimit = 0;
      } else if (this.hasLimit <= this.limit) {
        this.loading = false;
      }
      this.fileList.splice(index, 1);
      this.$emit("fileInput", this.listToString(this.fileList));
    },

    // 获取文件名称
     getFileName(name,i) {
             axios({
              method: 'get',
              url: process.env.NODE_ENV_TOW + '/file/get-file-name?url=' + name
            }).then(res => {
                this.fileList[i].name=res.data.data
            });
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
    //清除展示
    clearFiles() {
      this.$refs["uploadFile"].clearFiles();
      this.fileList = [];
    },
  },
};
</script>
<style>
  .el-message.el-message--success{
  height: 100px ;
  font-size: 30px;
}

.el-progress-bar__innerText{
  opacity: 0;
}
 .el-message__content{
  font-size: 30px  !important;
}
</style>
<style scoped lang="scss">
.upload-file-uploader {
  margin-bottom: 5px;
  float: left;
}
.upload-file-list {
  float: left;
}
.upload-file-list .el-upload-list__item {
  // border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
  margin: 0 0 0 20px;
  width: auto;
}
.ele-upload-list__item-content-action {
  margin-left: 10px;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
button {
  width: 96px;
  height: 32px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 2px;
  border: 1px solid #3a76ed;
  padding: 0px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3a76ed;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload/index.vue